// extracted by mini-css-extract-plugin
module.exports = {"resetPasswordBlock":"ResetPassword_resetPasswordBlock__3mHZi","resetPasswordBlock__logo":"ResetPassword_resetPasswordBlock__logo__GXZZe","spin":"ResetPassword_spin__1NkLs"};